module.exports = __webpack_public_path__ + "static/Icon3-a9d8f2579353c7f7bd8db0c6b22cb0b0.svg";